module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    ref: "pageShow"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('svg', {
    ref: "topSvg",
    staticClass: "orderID"
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.pickingData.StockOut.Warehouse.Name) + " " + _vm._s(_vm.pickingData.StockOut.Freight.Code) + " " + _vm._s(_vm.pickingData.StockOut.Types) + " " + _vm._s(_vm.pickingData.StockOut.OrderID) + " 拣货单")])])]), _vm._v(" "), _c('tr', [_c('th', [_c('h2', [_vm._v("订单总数：" + _vm._s(_vm.countData.OrderAll))])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("总包裹数：" + _vm._s(_vm.countData.PackageAll))])]), _vm._v(" "), _c('th', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.printPage
    }
  }, [_vm._v("打印")])], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tbody', {
    ref: "tableBody"
  }, _vm._l((_vm.pickingList), function(t) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('svg', {
      attrs: {
        "id": t.FreightNo
      }
    })]), _vm._v(" "), _c('td', _vm._l((t.Product), function(p) {
      return _c('p', {
        staticStyle: {
          "font-size": "18px"
        }
      }, [_vm._v("[" + _vm._s(p.FullSKU) + "] " + _vm._s(p.FullName) + " * " + _vm._s(p.Quantity * t.Quantity))])
    })), _vm._v(" "), _c('td', [_vm._v(_vm._s(t.Quantity))]), _vm._v(" "), _c('td', _vm._l((t.Stock), function(s) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "border-bottom": "1px solid #000"
        }
      }, [_vm._v("\n              " + _vm._s(s.Rcode) + " - " + _vm._s(s.OrderID.substr(s.OrderID.length - 4)) + "\n            ")])
    })), _vm._v(" "), _c('td', _vm._l((t.Stock), function(s) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "border-bottom": "1px solid #000"
        }
      }, [_vm._v("\n              " + _vm._s(s.Quantity) + "\n            ")])
    }))])
  }))])]), _vm._v(" "), _c('div', {
    ref: "printShow",
    staticStyle: {
      "display": "none"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("包裹")]), _vm._v(" "), _c('th', [_vm._v("包含产品")]), _vm._v(" "), _c('th', [_vm._v("包裹数量")]), _vm._v(" "), _c('th', [_vm._v("库位 - 批次号 ")]), _vm._v(" "), _c('th', [_vm._v("数量")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28cd3d25"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Picking.vue
// module id = 832
// module chunks = 1